import React from 'react';
import { Link } from 'react-router-dom';

const MoviesCtaSection = () => {
  return (
    <section aria-labelledby="movies-cta-title">
      <div className="bg-white p-8 rounded-lg border border-gray-200 shadow-lg site-card text-center">
        <h2 id="movies-cta-title" className="text-3xl font-bold text-gray-900">
          Voltar para o Laboratorio
        </h2>
        <p className="mt-4 text-lg text-gray-600">
          Essa pagina e o primeiro bloco da sua curadoria de filmes dentro do site.
        </p>
        <div className="mt-8">
          <Link
            to="/laboratorio"
            className="inline-flex items-center rounded-md bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
          >
            Ir para o Laboratorio
          </Link>
        </div>
      </div>
    </section>
  );
};

export default MoviesCtaSection;
